var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3C17.8954 3 17 3.89543 17 5V13C17 14.1046 17.8954 15 19 15H27C28.1046 15 29 14.1046 29 13V5C29 3.89543 28.1046 3 27 3H19ZM27 9C27 8.44772 26.5523 8 26 8L20 8C19.4477 8 19 8.44772 19 9C19 9.55228 19.4477 10 20 10H26C26.5523 10 27 9.55229 27 9Z",
    fill: "#DFDDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17C3.89543 17 3 17.8954 3 19V27C3 28.1046 3.89543 29 5 29H13C14.1046 29 15 28.1046 15 27V19C15 17.8954 14.1046 17 13 17H5ZM7.58577 25.8284C7.19524 26.2189 6.56208 26.2189 6.17156 25.8284C5.78103 25.4379 5.78103 24.8047 6.17156 24.4142L7.58582 22.9999L6.17168 21.5858C5.78116 21.1953 5.78116 20.5621 6.17168 20.1716C6.56221 19.7811 7.19537 19.7811 7.5859 20.1716L9.00003 21.5857L10.4142 20.1716C10.8047 19.781 11.4379 19.781 11.8284 20.1716C12.2189 20.5621 12.2189 21.1952 11.8284 21.5858L10.4142 22.9999L11.8285 24.4142C12.2191 24.8047 12.2191 25.4379 11.8285 25.8284C11.438 26.219 10.8048 26.219 10.4143 25.8284L9.00003 24.4141L7.58577 25.8284Z",
    fill: "#DFDDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C3.89543 3 3 3.89543 3 5V13C3 14.1046 3.89543 15 5 15H13C14.1046 15 15 14.1046 15 13V5C15 3.89543 14.1046 3 13 3H5ZM19 17C17.8954 17 17 17.8954 17 19V27C17 28.1046 17.8954 29 19 29H27C28.1046 29 29 28.1046 29 27V19C29 17.8954 28.1046 17 27 17H19ZM9 13C9.55229 13 10 12.5523 10 12V10H12C12.5523 10 13 9.55229 13 9C13 8.44772 12.5523 8 12 8H10V6C10 5.44772 9.55229 5 9 5C8.44772 5 8 5.44772 8 6L8 8H6C5.44772 8 5 8.44772 5 9C5 9.55228 5.44771 10 6 10H8V12C8 12.5523 8.44772 13 9 13ZM26.5355 19.4646C26.145 19.074 25.5118 19.074 25.1213 19.4646L19.4644 25.1214C19.0739 25.5119 19.0739 26.1451 19.4644 26.5356C19.8549 26.9261 20.4881 26.9261 20.8786 26.5356L26.5355 20.8788C26.926 20.4882 26.926 19.8551 26.5355 19.4646Z",
    fill: "#B4B4C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBudget);
export default __webpack_public_path__ + "static/media/menu-budget.30f820376db7fc1c4bba30be8e50dcd0.svg";
export { ForwardRef as ReactComponent };